<ispm-subject-list-cell
  *ngFor="let field of fields; trackBy: trackByField; last as isLastColumn;"
  [field]="field"
  [editVisible]="editVisible"
  [editable]="editable"
  [selected]="selected"
  [subjectsAppearance]="subjectsAppearance"
  [subject]="subject"
  (editTherapyClicked)="editTherapy(field)"
  (includeInStatusChange)="includeInChange($event)"
  [value]="value"
  [previewMode]="previewMode$ | async"
></ispm-subject-list-cell>
<section *ngIf="!hideCheckBox">
  <p-checkbox [ngModel]=subject.therapy (ngModelChange)="updateTherapyChecked($event)" [binary]="true" [disabled]="isCheckBoxDisabled()"></p-checkbox>
</section>
